import { createFileRoute } from "@tanstack/react-router";
import { Locations } from "@/features/settings/locations";

export const Route = createFileRoute("/settings/locations")({
  component: Locations,
});
